module.exports = __webpack_public_path__ + "img/mtn-logo-nav.938c0953.svg";